import { alpha } from "../../utils/muiCompat";
import { Theme } from "@material-ui/core";

const colunaFlexivel = { display: "flex", flexDirection: "column" as "column", flexGrow: 1, minHeight: 0 };

const styles = (theme: Theme) => ({
  root: {
    position: "relative" as "relative",
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${
      theme.palette.type === "dark" ? theme.palette.divider : alpha(theme.palette.primary.main, 0.25)
    }`,
    borderRadius: 12,
    boxShadow: "none",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      marginBottom: theme.spacing(2),
    },
    "&$noMargin": {
      margin: 0,
    },
  },
  // Com poucos registros o card ficava curto no topo e sobrava meia tela vazia embaixo
  preencheAltura: {
    display: "flex",
    flexDirection: "column" as "column",
    [theme.breakpoints.up("md")]: {
      minHeight: "max(360px, calc(var(--altura-tela, 100vh) - 220px))",
      // sem esticar a tabela junto, a paginacao ficava no meio do card e o vazio depois dela
      "& > section": colunaFlexivel,
      "& > section > div:first-child": colunaFlexivel,
      "& [class*='MUIDataTable-paper']": colunaFlexivel,
      "& [class*='MUIDataTable-responsive']": { flexGrow: 1, minHeight: 0 },
      "& [class*='MUIDataTable-paper'] > table": { borderTop: `1px solid ${theme.palette.divider}` },
    },
  },
  descBlock: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: 10,
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(3),
      flexDirection: "column" as "column",
      alignItems: "stretch",
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: 10,
    },
  },
  titleText: {
    flex: 1,
    minWidth: 0,
  },
  botaoFiltro: {
    flexShrink: 0,
    marginLeft: theme.spacing(2),
    // A lupa do datatable e absoluta no canto do card (MUIDataTableToolbar.actions):
    // no fluxo o Filtrar caia embaixo dela. Ancorar os dois na mesma linha, com o
    // Filtrar crescendo para a esquerda, dispensa saber a largura do botao.
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      marginTop: theme.spacing(1.5),
    },
    [theme.breakpoints.up('md')]: {
      position: 'absolute' as 'absolute',
      top: 10,
      right: 72,
      marginLeft: 0,
    },
  },
  descBlockComAcoes: {
    [theme.breakpoints.up('md')]: {
      minHeight: 40,
    },
  },
  title: {
    position: "relative",
    fontFamily: ["Roboto", "sans-serif"].join(","),
    fontSize: 30,
    fontWeight: 800,
    color: theme.palette.type === "dark" ? theme.palette.primary.light : theme.palette.primary.dark,
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      fontSize: 22,
      marginBottom: theme.spacing(),
    },
  },
  centerTitle: {
    "& $title": {
      textAlign: "center",
    },
    "& $description": {
      textAlign: "center",
    },
  },
  description: {
    paddingTop: theme.spacing() / 2,
    color: theme.palette.type === "dark" ? theme.palette.primary.light : theme.palette.primary.main,
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
    },
  },
  content: {
    marginTop: 0,
    padding: theme.spacing(),
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 1,
    backgroundColor: "transparent",
    [theme.breakpoints.up("lg")]: {
      padding: theme.spacing(),
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 1,
    },
  },
  whiteBgNormal: {
    backgroundColor: "transparent",
  },
  whiteBg: {
    backgroundColor: "transparent",
    margin: 0,
    padding: 0,
  },
  noMargin: {},
  plain: {
    border: "none",
    backgroundColor: "transparent",
    borderRadius: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
  colorMode: {
    backgroundColor: theme.palette.type === "dark" ? theme.palette.primary.dark : theme.palette.primary.main,
    "& $title": {
      color: theme.palette.grey[100],
      "&:after": {
        borderBottom: `5px solid ${theme.palette.primary.light}`,
      },
    },
    "& $description": {
      color: theme.palette.grey[100],
    },
  },
  overflowX: {
    width: "100%",
    overflowX: "auto",
  },
  tableMobile: {
    width: 500,
    overflowX: "auto",
  },
});

export default styles;
